import React from "react";
import { Link } from "react-router-dom";

const UserLink = ({ id, userId, name, className = "", role, to, playing }) => {
    // Accept both id and userId for flexibility
    const finalId = id || userId;

    if (!finalId || !name) {
        return <span>{name || "-"}</span>;
    }

    // If custom className is provided, use it; otherwise use default blue styling
    const linkClassName = className || "text-blue-600 hover:text-blue-800";
    const href = to
        || (playing ? `/playing/players/${finalId}` : `/users/${finalId}`);

    return (
        <Link
            to={href}
            className={`hover:underline font-medium cursor-pointer transition-colors ${linkClassName}`}
        >
            {name}
        </Link>
    );
};

export default UserLink;
